<template>
  <main class="supplier-blank-layout">
    <div class="page-container">
      <slot />
    </div>
  </main>
</template>

<style lang="scss" scoped>
.supplier-blank-layout {
  --supplier-header-height: 0px;

  min-height: 100vh;
  padding: 24px 0 48px;
}
</style>
